import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'invalid-user',
  templateUrl: './invalid-user.component.html',
  standalone: false
})
export class InvalidUserComponent implements OnDestroy  {
  public title: string = 'Invalid User Security Settings';

  public ngOnDestroy(): void {
    // No manual unsubscribe needed when using takeUntilDestroyed
  }
}
